export default __webpack_public_path__ + "static/media/entryfish_felhasznaloi_kezikonyv.e965933b.pdf";